/**
 * Pagination Go to Page
 */

export default function CustomerPagiation() {
    const selectors = {
        'input': '.go-in-200 input'
    }

    this.init = () => {
        var max_input = parseInt(jQuery(selectors.input).attr('max'), 10);
        jQuery(".go-in-200 a").click(function (e) {
            e.preventDefault();
            var href = jQuery(this).attr('href');
            var input = jQuery(this).parent().find("input");
            var number = parseInt(input.val(), 10);
            if (number != '0' && number <= max_input) {
                window.location.href = href + 'page/' + number + '/';
            }
        });

        jQuery(selectors.input).on('input change', function () {
            var maxValue = parseInt(jQuery(this).attr('max'));
            var minValue = parseInt(jQuery(this).attr('min'));

            var currentValue = parseInt(jQuery(this).val());
            if (currentValue < minValue) {
                jQuery(this).val(minValue); // If the value is less than the minimum, assign the minimum value again
            }
            if (currentValue > maxValue) {
                jQuery(this).val(maxValue); // If the value is greater than max, assign the value of max again
            }
        });
        jQuery(selectors.input).keyup(function (e) {
            var href = jQuery(this).parent().find('a').attr('href');
            var number = parseInt(jQuery(this).val(), 10);
            if (e.keyCode == 13 && number != '0') {
                if (number != 0 && number <= max_input) {
                    window.location.href = href + 'page/' + number + '/';
                }
            }
        });
    }
}